import { grommet, Text } from "grommet";
import { deepMerge } from "grommet/utils";
import { ThemeType } from "grommet/themes";
import React from "react";
import { css } from "styled-components";

const params = new URLSearchParams(window.location.search.toLocaleLowerCase());

export const DefaultSizes = ["xxsmall", "xsmall", "small", "medium", "large", "xlarge"];

const presenceTheme: ThemeType = {
    global: {
        font: {
            size: "16px",
            family: "HyperLegible",
        },
        colors: {
            /* BEGIN: Color Palette Definition */
            brand: "var(--accent,#00aced)",
            "accent-1": "#00aced", // Primary cyber blue
            "accent-2": "#0090ea", // Secondary cyber blue
            "accent-3": "#2b5cc4", // Deep electric blue
            "accent-4": "#4338ca", // Cool indigo
            "light-1": "#f7f7f7",
            "light-2": "#e1e1e1",
            "light-3": "#b1b1b1",
            "dark-1": "#0c0e12",
            "dark-2": "#212224bf",
            "dark-3": "#3b3b3b",
            "status-critical": "#ef4444", // Red
            "status-warning": "#3b82f6", // Blue instead of yellow/orange
            "status-ok": "#00aced", // Cyber blue instead of green
            "status-unknown": "#6366f1", // Cool indigo instead of grey
            /* END: Color Palette Definition */
            /* BEGIN: Mapping Colors to Grommet Namespaces */
            background: {
                dark: "dark-1",
                light: "light-1",
            },
            "background-back": {
                dark: "dark-2",
                light: "light-2",
            },
            "background-front": {
                dark: "dark-3",
                light: "light-3",
            },
            "background-contrast": {
                dark: "light-3",
                light: "dark-3",
            },
            control: {
                dark: "brand",
            },
            glass: {
                dark: "rgba(0,0,0,0.2)",
                light: "rgba(255,255,255,0.2)",
            },
        },
        focus: {
            border: {
                color: "none",
            },
        },
        /* END: Mapping Colors to Grommet Namespaces */
    },
    /* BEGIN: Mapping Colors to Components */
    anchor: {
        color: "text",
        hover: {
            textDecoration: "none",
        },
    },
    button: {
        border: {
            radius: "4px",
        },
        size: {
            small: {
                border: {
                    radius: "4px",
                },
            },
            medium: {
                border: {
                    radius: "4px",
                },
            },
            large: {
                border: {
                    radius: "4px",
                },
            },
        },
    },
    grommet: {
        extend: {
            background: params.get("background") || "background-back",
        },
    },
    layer: {
        background: {
            dark: "background",
            light: "background",
        },
    },
    menu: {
        background: {
            dark: "background",
            light: "background",
        },
    },
    tip: {
        content: {
            background: {
                dark: "dark-2",
                light: "light-2",
            },
        },
    },
    formField: {
        label: {
            requiredIndicator: (
                <Text a11yTitle="required" color="status-critical">
                    *
                </Text>
            ),
        },
    },
    card: {
        container: {
            elevation: "none",
        },
    },
    text: {
        extend: css`
            font-weight: normal;
        `,
    },
    /* END: Mapping Colors to Components */
};

const Theme = deepMerge(grommet, presenceTheme);

export default Theme;
